import { render, staticRenderFns } from "./ResendConfirmation.vue?vue&type=template&id=294b111a&"
import script from "./ResendConfirmation.vue?vue&type=script&lang=ts&"
export * from "./ResendConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./ResendConfirmation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports